import { ReactNode } from 'react';

import { Button, Spinner } from '@iwoca/orion';
import { Link } from 'react-router';

import { useGetContext } from '../../api/lending/lapiHooks';
import { ErrorBoundary } from '../../AppWrapper';
import { buildQueryString } from '../../Buyer/utils/queryParams';
import iwocaPayLogo from '../../components/svg/iwocaPayLogo.svg';
import { useAccountNavigation } from '../../hooks/useAccountNavigation';

export const PageNotFound = () => {
  const {
    context: { isLoggedIn, isLoading },
  } = useGetContext();
  const { getAccountUrl, useCirceAccountPages } = useAccountNavigation();

  const DashboardButton = () => {
    const Shell = ({ children }: { children: ReactNode }) => {
      return (
        <div className="mt-2xl flex h-[50px] items-center justify-center">
          {children}
        </div>
      );
    };

    if (isLoading) {
      return (
        <Shell>
          <Spinner />
        </Shell>
      );
    }

    const accountUrl = getAccountUrl(buildQueryString());
    const linkContent = (
      <Shell>
        <Button>
          <>{isLoggedIn ? 'Go to dashboard' : 'Go to login'}</>
        </Button>
      </Shell>
    );

    if (useCirceAccountPages) {
      return (
        <Link to={accountUrl} className="no-underline">
          {linkContent}
        </Link>
      );
    }

    return (
      <a href={accountUrl} className="no-underline">
        {linkContent}
      </a>
    );
  };

  return (
    <ErrorBoundary>
      {useCirceAccountPages ? (
        <Link to={getAccountUrl(buildQueryString())}>
          <img
            src={iwocaPayLogo}
            alt="iwocaPay logo"
            aria-hidden="true"
            className="fixed left-l top-l"
          />
        </Link>
      ) : (
        <a href={getAccountUrl(buildQueryString())}>
          <img
            src={iwocaPayLogo}
            alt="iwocaPay logo"
            aria-hidden="true"
            className="fixed left-l top-l"
          />
        </a>
      )}
      <div className="flex min-h-screen items-center justify-center">
        <div className="mt-[-80px] max-w-md">
          <h1 className="mt-0 text-5xl">404</h1>
          <p className="text-l font-reg">
            Oops! Looks like we couldn’t find what you were looking for.
          </p>
          <p className="text-m font-reg text-structure-20">
            Please check the URL or go back and try again.
          </p>

          {/* eslint-disable-next-line react-hooks/static-components -- inner component closes over parent state/props */}
          <DashboardButton />
        </div>
      </div>
    </ErrorBoundary>
  );
};
